import AvailableNow from "./AvailableNow.vue";

export default AvailableNow;
